import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "tree-item" };
const _hoisted_2 = { class: "simple-text" };
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 0,
    class: "operation-container",
    role: "presentation"
};
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("g", null, [
    /*#__PURE__*/ _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
], -1);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = {
    key: 0,
    class: "child-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_treeview_item = _resolveComponent("g-treeview-item", true);
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['tree-node', _ctx.level > 0 ? 'level-' + _ctx.level : ''])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_g_link, {
                onLinkClick: _ctx.onExpand,
                src: _ctx._linkUrl,
                class: _normalizeClass([_ctx.dataItem.cssClasses, _ctx._isSelected ? 'active' : 'normal'])
            }, {
                default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, [
                        (_ctx.dataItem?.iconUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.dataItem?.iconUrl,
                                width: "24",
                                height: "24",
                                style: { "max-width": "24px", "max-height": "24px" }
                            }, null, 8, _hoisted_3))
                            : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
                    ]),
                    (_ctx._hasChildren)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                            (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass([_ctx._isExpanded ? 'expand-icon__opened' : 'expand-icon__closed']),
                                preserveAspectRatio: "xMidYMid meet",
                                height: "1em",
                                width: "1em",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                stroke: "currentColor"
                            }, _hoisted_6, 2))
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["onLinkClick", "src", "class"])
        ]),
        (_ctx._isExpanded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (node) => {
                    return (_openBlock(), _createBlock(_component_g_treeview_item, {
                        level: _ctx.level + 1,
                        label: node.caption,
                        "data-item": node,
                        "get-children": _ctx.getChildren,
                        "has-children": _ctx.hasChildren
                    }, null, 8, ["level", "label", "data-item", "get-children", "has-children"]));
                }), 256)),
                _renderSlot(_ctx.$slots, "children")
            ]))
            : _createCommentVNode("", true)
    ], 2));
}
